import {Injectable} from "@angular/core";
import {HttpErrorResponse} from "@angular/common/http";
import {
  INVALID_PROMO_CODE,
  PROMO_ALREADY_USED_RESPONSE,
  PROMO_CODE_UNIQUE_RESPONSE,
  PROMO_EXPIRED_RESPONSE,
  PROMO_LIMIT_EXPIRATION_RESPONSE
} from "../../constants/promo-code.constant";

@Injectable({
  providedIn: 'root'
})
export class PromoCodeUtil {

  public static isPromoCodeNotFound(error: HttpErrorResponse) {
    return error.status == 404;
  }

  public static isPromoCodeLimitExpired(error: HttpErrorResponse) {
    return error.error.message.startsWith(PROMO_LIMIT_EXPIRATION_RESPONSE);
  }

  public static isPromoCodeAlreadyUsed(error: HttpErrorResponse) {
    return error.error.message.startsWith(PROMO_ALREADY_USED_RESPONSE);
  }

  public static isPromoCodeExpired(error: HttpErrorResponse) {
    return error.error.message.startsWith(PROMO_EXPIRED_RESPONSE);
  }

  public static isPromoCodeInvalid(error: HttpErrorResponse) {
    return error.error.message.startsWith(INVALID_PROMO_CODE);
  }

  public static isPromoCodeDuplicate(error: HttpErrorResponse) {
    return error.status === 409 && error.error.message.startsWith(PROMO_CODE_UNIQUE_RESPONSE);
  }
}
